import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  baseStyle: {
    fontFamily: 'MAN-light, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: '300',
    color: '#303a44',
    lineHeight: 1.5
  },
  superSmallStyle: {
    fontSize: theme.typography.pxToRem(10),
    color: '#838a92'
  }
})

const SmallText = ({
  classes: { baseStyle, superSmallStyle },
  className,
  component,
  superSmall,
  children,
  ...otherProps
}) => {
  const textClass = classNames(
    baseStyle,
    superSmall ? superSmallStyle : '',
    className
  )
  return (
    <Typography
      component={component || 'p'}
      className={textClass}
      {...otherProps}
    >
      {children}
    </Typography>
  )
}

SmallText.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  superSmall: PropTypes.bool,
  children: PropTypes.node
}

export default withStyles(styles)(SmallText)



// WEBPACK FOOTER //
// ./src/styleguide/SmallText.js